<template>
    <div class="text-center text-lg-left pb-4 pb-lg-0 h-auto pt-3 pt-lg-0">

        <div class="d-flex flex-column flex-lg-row justify-content-between align-items-center">
            <h1 class="font-weight-400 text-2 text-white-50">
                {{ fullText || `Buy ${where}` }}
            </h1>
            <div v-if="slides">
                <span :key="s" :title="'Slide ' + (s + 1)"
                      v-for="(s, i) in slides.length"
                      @click="currentSlide = i"
                      :class="{ 'text-white' : currentSlide === i }"
                      class="mx-1 text-9 pointer">&bull;</span>
            </div>
        </div>

        <carousel v-model="currentSlide" :slides="slides ? slides : [{ title, subtitle }]">
            <template v-slot:default="{ slide }">
                <h2 class="text-white mb-4 font-weight-bolder"
                    :class="[isMobile ? 'text-9' : 'text-13']"
                    v-html="slide['title'].replace(/\n/g, '<br />')"></h2>

                <p class="text-white-50 mb-3"
                   :class="{'text-3': !isMobile, 'text-2': isMobile }"
                   v-html="slide['subtitle'].replace(/\n/g, '<br />')">
                </p>
            </template>
        </carousel>

        <slot>
            <div v-if="!hideButton"
                 class="d-flex flex-column flex-lg-row justify-content-center justify-content-lg-start align-items-center mb-4">
                <a target="_blank" href="https://api.whatsapp.com/send/?phone=263785832033&text=Hi+Magetsi"
                   class="btn btn-success px-4">
                    <i class="fab fa-whatsapp mr-3"></i>
                    {{ btnText || `Buy ${where}` }} on WhatsApp
                </a>

                <template v-if="buttons.length">
                    <component :is="b[1].startsWith('#') ? 'a' : 'router-link'"
                               :key="b[1]" v-for="b in buttons"
                               :to="b[1]" :href="b[1]"
                               class="btn bg-white-50 hover:bg-white-100 text-white m-2">
                        {{ b[0] }}
                    </component>
                </template>

                <a href="#content" class="d-none d-lg-inline-block px-4 text-white-50">
                    or buy now <i class="fa fa-arrow-right ml-2"></i>
                </a>
            </div>

            <div class="d-none d-lg-block">
                <div v-if="!hidePaymentMethods" style="border-color: rgba(255, 255, 255, 0.1) !important; border-width: 4px"
                     class="border rounded-lg text-white text-10 mb-5 px-4 py-2">
                    <span class="text-white-50 text-1 mb-2">Pay with</span>
                    <div class="d-flex justify-content-between align-items-center">
                        <img src="/img/EcoCash.svg" height="30" width="164" alt="">
                        <img src="/img/mc_vrt_rev.svg" height="60" width="74" alt="">
                        <img src="/img/Visa.svg" height="30" width="93" alt="">
                    </div>
                </div>
                <div v-if="!hideMiscDetails" class="row text-white-50">
                    <div class="col-sm-6 col-md-6 d-flex">
                        <div class="col-4">
                            <div class="text-12 mb-4"><i class="fas fa-lock"></i></div>
                        </div>
                        <div class="flex-grow-1">
                            <h5 class="text-white-50">100% secure payments</h5>
                            <p>Moving your card details to a much more secure place.</p>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-6 d-flex">
                        <div class="col-4">
                            <div class="text-12 mb-4"><i class="far fa-life-ring"></i></div>
                        </div>
                        <div class="flex-grow-1">
                            <h5 class="text-white-50">24/7 Support</h5>
                            <p>We're here to help. Have a query and need help ?</p>
                        </div>
                    </div>
                </div>
            </div>

        </slot>
    </div>
</template>

<script>
import {windowSize} from "../../core/utils/window-size";

export default {
    name: "welcome-info",
    components: {Carousel: () => import("../custom/carousel.vue")},
    mixins: [windowSize],
    props: {
        where: String,
        title: String,
        subtitle: {
            type: String,
            default: 'Magetsi is a digital omni-channel platform that provides ' +
                'an array of payment services through web, WhatsApp, Facebook, and other channels. ' +
                'Accepted payment methods on our platform include EcoCash, MasterCard, VISA, and other' +
                ' international cards.'
        },
        slides: Array,
        fullText: String,
        btnText: String,
        promotion: String,
        hideButton: {
            type: Boolean,
            default: false
        },
        hidePaymentMethods: {
            type: Boolean,
            default: false
        },
        hideMiscDetails: {
            type: Boolean,
            default: false
        },
        buttons: {
            type: Array,
            default: () => []
        },
    },
    data: () => ({
        currentSlide: 0
    })
}
</script>

